<template>
  <ODialog
    ref="dialog"
    :title="$t('components.resourceType.actions.delete.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { ResourceType } from '~/_api/models/resourceType'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref()
const resourceType = ref<ResourceType | null>(null)

const info = computed(() => {
  return $i18n.t('components.resourceType.actions.delete.info', {
    name: resourceType.value?.name,
    id: resourceType.value?.idResourceType,
  })
})

const open = (item: ResourceType) => {
  resourceType.value = item
  dialog.value.open()
}

const confirm = async () => {
  if (!resourceType.value) return

  emit('update:loading', true)

  try {
    const response = await $api.resourceType.delete(resourceType.value)

    if (response.success) {
      $notification.toast({
        title: $i18n.t('components.resourceType.actions.delete.success'),
        text: $i18n.t('components.resourceType.actions.delete.successInfo', { name: resourceType.value.name }),
      })

      emit('success')
      $bus.emit.deleted('ResourceType', resourceType.value)

      return true
    }
  } catch (e) {
    console.log(e)

    $notification.toast({
      title: $i18n.t('components.resourceType.actions.delete.error'),
      text: $i18n.t('components.resourceType.actions.delete.errorInfo', { name: resourceType.value?.name }),
    })

    emit('error')
  }
}

defineExpose({
  open,
})
</script>
